// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__DataGridHeader__VXCXi{flex-direction:row}.sputnik__DataGridHeader-search__LTm4L{flex-grow:0}`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/CreditApplicationsDataGrid/DataGridHeader/styles.module.scss"],"names":[],"mappings":"AAAA,gCACE,kBAAA,CAEA,uCACE,WAAA","sourcesContent":[".DataGridHeader {\n  flex-direction: row;\n\n  &-search {\n    flex-grow: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DataGridHeader": `sputnik__DataGridHeader__VXCXi`,
	"DataGridHeader-search": `sputnik__DataGridHeader-search__LTm4L`
};
export default ___CSS_LOADER_EXPORT___;
